export default __webpack_public_path__ + "static/media/profile-ownership-white.946efcb1.svg";